import { useEffect, useState } from "react";
import { EVENT5K } from "@/constants/testIds";

const EVENT_DATE = new Date("2026-11-07T09:00:00-05:00");

function timeLeft() {
  const diff = EVENT_DATE.getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
}

const Cell = ({ v, label, tid }) => (
  <div className="flex flex-col items-center min-w-[52px] md:min-w-[80px]">
    <div
      data-testid={tid}
      className="font-display text-3xl md:text-5xl lg:text-6xl font-black text-white text-shadow-glow-green tabular-nums"
    >
      {String(v).padStart(2, "0")}
    </div>
    <div className="mt-1 text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-[#A3A3A3]">
      {label}
    </div>
  </div>
);

const Sep = () => (
  <div className="font-display text-2xl md:text-4xl lg:text-5xl text-[#EC008C]">:</div>
);

export default function Countdown() {
  const [t, setT] = useState(timeLeft());
  useEffect(() => {
    const id = setInterval(() => setT(timeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex items-center justify-between gap-1.5 md:gap-3 w-full">
      <Cell v={t.d} label="Days" tid={EVENT5K.countdownDays} />
      <Sep />
      <Cell v={t.h} label="Hours" tid={EVENT5K.countdownHours} />
      <Sep />
      <Cell v={t.m} label="Minutes" tid={EVENT5K.countdownMinutes} />
      <Sep />
      <Cell v={t.s} label="Seconds" tid={EVENT5K.countdownSeconds} />
    </div>
  );
}
